<template>
  <div class="container-outer" ref="outerElement">
    <ScrollArea ref="scrollElementRef" :fade="fade">
      <div class="container-inner" ref="innerElement">
        <slot />
      </div>
    </ScrollArea>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useTemplateRef } from 'vue';

import ScrollArea from './scroll-area.vue';

/** `fade` softens the edge that still has cards out of view (see `ScrollArea`) */
defineProps<{ fade?: boolean }>();

const outerElement = ref<HTMLElement>();
const innerElement = ref<HTMLElement>();
const scrollElementRef = useTemplateRef('scrollElementRef');

defineExpose({
  outerElement,
  innerElement,
  scrollElement: computed(() => scrollElementRef.value?.$el),
});
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.container-outer {
  --container-padding: var(--t-app-layout-padding);

  overflow: hidden;
  margin: calc(var(--container-padding) * -1);
}

.container-inner {
  width: max-content;
  min-width: 100%;
  padding: var(--container-padding);

  @include mobile {
    width: 100%;
  }
}
</style>
